import addWedissimoUserModalStore from '@/components/pages/Users/organisms/AddWedissimoUserModal/addWedissimoUserModalStore';
import AddWedissimoUserStep from '@/components/pages/Users/organisms/AddWedissimoUserModal/molecules/AddWedissimoUserStep';
import WedissimoSeatAddedStep from '@/components/pages/Users/organisms/AddWedissimoUserModal/molecules/WedissimoSeatAddedStep';

export default {
  defaultStep: AddWedissimoUserStep.key,
  steps: {
    [AddWedissimoUserStep.key]: {
      ...AddWedissimoUserStep,
      onNextClick: ({
        elements,
        formContext,
        profile,
        setCurrentStep,
        stripe,
        usersStore,
        showErrorToast,
      }) => async () => {
        addWedissimoUserModalStore.setNewUser(formContext.getValues());

        try {
          await addWedissimoUserModalStore.onSubmit({
            profile,
          });

          setCurrentStep(WedissimoSeatAddedStep.key);
        } catch (error) {
          showErrorToast(error.message?.message ?? error.message);
        }
      },
    },
    [WedissimoSeatAddedStep.key]: {
      ...WedissimoSeatAddedStep,
      onNextClick: () => addWedissimoUserModalStore.close,
    },
  },
};
